import { serviceType } from '../topUpAddons/singleSubscription';
import modelsResolver from '../utils/modelsResolver';
import { SingleLoyaltyNumber } from './singleLoyaltyNumber';

export type SubscriptionDetails = {
	id: number;
	recurrence: string;
	type: serviceType;
	target: string;
	oneTimeAmount: number;
	totalAmount: number;
	paymentType: string;
	status: string;
	startDate: string;
	endDate: string;
	_numbers: any;
	numbers: SingleLoyaltyNumber[];
};

const model: types.models.InputModel = {
	id: 'response.id',
	recurrence: 'response.recurrence',
	type: 'response.type',
	target: 'response.target',
	oneTimeAmount: 'response.oneTimeAmount',
	totalAmount: 'response.totalAmount',
	paymentType: 'response.paymentType',
	status: 'response.status',
	startDate: 'response.startDate',
	endDate: 'response.endDate',
	_numbers: ['response.numbers', []],
	numbers: (model: SubscriptionDetails) => {
		return model._numbers.map((number: any) => {
			return modelsResolver(number, 'singleLoyaltyNumber');
		});
	},
};

export default model;
